import React from "react";
import PropTypes from "prop-types";
import { Typography, Card, useTheme } from "@material-ui/core";
import { Line } from "react-chartjs-2";
import { options } from "./constants";
import useStyles from "./styles";

const ChartTile = ({ title, count, chart }) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <div className={classes.container}>
      <Card className={classes.card}>
        <div className={classes.chart}>
          {chart.datasets ? (
            <Line
              data={{
                labels: chart.labels,
                datasets: chart.datasets.map((obj) => ({
                  ...obj,
                  borderColor: theme.palette.secondary.main,
                })),
              }}
              options={options.line}
              width={101}
              height={96}
            />
          ) : null}
        </div>
        <div>
          <Typography className={classes.title} color="textSecondary" variant="h6">
            {title}
          </Typography>
          <Typography className={classes.count}>{count}</Typography>
        </div>
      </Card>
    </div>
  );
};

ChartTile.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  chart: PropTypes.shape({ labels: PropTypes.arrayOf(PropTypes.string), dataset: PropTypes.arrayOf(PropTypes.object) }),
};

ChartTile.defaultProps = {
  title: "Open",
  count: 0,
  chart: { labels: [], datasets: [{ data: [], fill: false }] },
};

export default ChartTile;
